import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { ApprovalTypeRepository } from '@/store/approval-type-state/approval-type-state.repository';

interface IgetApprovalTypeAddDrawerObjectProps {
  store?: ApprovalTypeRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getApprovalTypeAddDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IgetApprovalTypeAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.approvalType.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.approvalType.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.approvalType.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
